import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface ToastProps {
  message: string | string[];
  toastProps?: any;
}

const Toast: React.FC<ToastProps> = ({ message, toastProps }) => {
  const { t } = useTranslation();

  let messages;

  if (typeof message === 'string') {
    messages = <div className="h6 m-0">{message}</div>;
  } else {
    messages = (
      <ul className="ps-4 m-0">
        {(message || []).map((item) => (
          <li className="h6 m-0">{item}</li>
        ))}
      </ul>
    );
  }

  return (
    <div className="w-100">
      <div className="col-12 d-flex p-2 toast-header-border-bottom align-items-center">
        <i
          className={clsx(
            toastProps.type === 'success' && 'ri-checkbox-circle-fill text-success',
            toastProps.type === 'error' && 'ri-error-warning-fill text-danger',
            'me-3 ri-22px'
          )}
        ></i>
        <div
          className={clsx(
            'h6 m-0',
            toastProps.type === 'success' && 'text-success',
            toastProps.type === 'error' && 'text-danger'
          )}
        >
          {toastProps.type === 'success' ? t('common.toast.success') : t('common.toast.error')}
        </div>
      </div>

      <div className="col-12 p-3">{messages}</div>
    </div>
  );
};

export default Toast;
